export default __webpack_public_path__ + "static/media/apartment_block_blue.e9d3f2f3.svg";